import http from '@/request/index'

// 获取产品中心列表
export function getProductCenterList(params) {
  return http.get('/pcenter', {
    ...params,
    timestamp: new Date().getTime() // 添加时间戳避免缓存
  })
}

// 获取产品分页列表
export function getProductPageList(product, query = {}) {
  return http.get('/pcenter/page', {
    ...product,
    ...query,
    timestamp: new Date().getTime()
  })
}

//获取产品分页列表 模拟 pcenter/products?typeName=XXX
export function getProductPageListByTypeName(typeName, query = {}) {
  return http.get(`/pcenter/products?typeName=${typeName}`, {
    ...query,
    timestamp: new Date().getTime()
  })
}

// 获取产品详情
export function getProductDetail(productId,  query) {
  return http.get(`/pcenter/detail/${productId}`, {
    preview: query.preview,
    timestamp: new Date().getTime()
  })
}

// 获取产品简要信息
export function getProductBrief(productId) {
  return http.get(`/pcenter/${productId}`, {
    timestamp: new Date().getTime()
  })
}

// 获取产品分类
export function getProductCategory(params) {
  return http.get(`/pcenter/types`, {
    ...params,
    timestamp: new Date().getTime()
  })
}

//产品推荐列表
export function getProductRecommendList(params) {
  return http.get('/pcenter/recommends', {
    ...params,
    timestamp: new Date().getTime() // 添加时间戳避免缓存
  })
}

// 下载资源列表
export function getProductResourceList(params) {
  return http.get('/anon/download', {
    ...params,
    timestamp: new Date().getTime() // 添加时间戳避免缓存
  })
}
